import React from "react";
import GenericLayout from "layouts/generic";
import css from "./index.module.scss";
import FloatingImageSection from "sections/floatingImage";
import Card from "@/components/card";
import StripedCtaSection from "sections/stripedCta";
import TacticsSection from "sections/tactics";
import Button from "@/components/button";

import IaaSvg from "/public/images/logos/iaa/iaa.svg";
import DeviateTrackingSvg from "/public/images/logos/deviateTracking/deviateTracking.svg";
import UpPaintSvg from "/public/images/logos/uppaint/uppaint.svg";
import BoeroSvg from "/public/images/logos/boero/boero.svg";
import AfterglowSvg from "/public/images/logos/afterglow/afterglow.svg";
import FlycoinSvg from "/public/images/logos/flycoin/flycoin.svg";
import GoSchoolBoxSvg from "/public/images/logos/goSchoolBox/goSchoolBox.svg";
import CarbonCrusherSvg from "/public/images/logos/carbonCrusher/carbonCrusher.svg";
import KavSvg from "/public/images/logos/kav/kav.svg";
import KojoSvg from "/public/images/logos/kojo/kojo.svg";
import UrsaMajorSvg from "/public/images/logos/ursaMajor/ursaMajor.svg";
import InnerPlantSvg from "/public/images/logos/innerplant/innerplant.svg";
import AskSeedsSvg from "/public/images/logos/askseeds/fullaskseeds.svg";
import TravelNannySvg from "/public/images/logos/travelnanny/travelnanny.svg";
import BuildHubSvg from "/public/images/logos/buildhub/buildhub.svg";



export default function ServicesPage() {
  let ventures = [
    {
      url: "https://immersiveaudioalbum.com",
      image: <IaaSvg/>,
    },
    {
      url: "https://deviatetracking.com",
      image: <DeviateTrackingSvg/>,
    },
    {
      url: "https://uppaint.com",
      image: <UpPaintSvg/>,
    },
    {
      url: "https://boerousa.com",
      image: <BoeroSvg/>,
    },
    {
      url: "https://xoafterglow.com",
      image: <AfterglowSvg/>,
    },
    {
      url: "https://flycoin.org",
      image: <FlycoinSvg/>,
    },
    {
      url: "https://goschoolbox.com",
      image: <GoSchoolBoxSvg/>,
    },
    {
      url: "https://www.carboncrusher.io",
      image: <CarbonCrusherSvg/>,
    },
    {
      url: "https://kavsports.com",
      image: <KavSvg/>,
    },
    {
      url: "https://www.usekojo.com",
      image: <KojoSvg/>,
    },
    {
      url: "https://www.ursamajor.com",
      image: <UrsaMajorSvg/>,
    },
    {
      url: "https://innerplant.com",
      image: <InnerPlantSvg/>,
    },
    {
      url: "https://askseeds.com",
      image: <AskSeedsSvg/>,
    },
    {
      url: "https://travelnanny.com",
      image: <TravelNannySvg/>,
    },
    {
      url: "https://www.buildhubapp.com",
      image: <BuildHubSvg/>,
    },
  ];

  return <GenericLayout
    title="Deviate Ventures | Investment Arm of Deviate Labs"
    description="Deviate Ventures, the investment arm of Deviate Labs, prides itself in its ability to provide marketing advisory services for all portfolio companies."
    color="pink"
  >
    <FloatingImageSection
      headlines={["Deviate Ventures &", "Incubator"]}
      floatingImageBase="/images/floatingImages/balloon/balloon"
      floatingImageSizes={["180", "384", "640"]}
      floatingImageLoading="eager"
      ctaLabel="Contact Us"
      ctaUrl="/contact"
    >
      <p>The independent, industry-agnostic investment arm of Deviate Labs that backs early-stage startups while leveraging our world-class consulting experience to provide marketing strategy value-add. Additionally, we have an in-house startup studio that incubates and accelerates products developed by our team.</p>
    </FloatingImageSection>

    <section className={`section ${css.cards}`}>
      <div className="sectionInner">
        <Card headline="Industry Focus">
          <p>We are industry agnostic and have invested in everything from education technology, to transportation technology, to paint manufacturing, and beyond.</p>
        </Card>
        <Card headline="Stage Focus">
          <p>While we have a bias for early-stage, we have written later-stage checks for investments as well. A select number of investments such as <a className="link" href="https://immersiveaudioalbum.com">ImmersiveAudioAlbum.com</a> and <a className="link" href="https://deviatetracking.com">Deviate Tracking</a> are in-house spin-outs from our consulting operations.</p>
        </Card>
        <Card headline="Check Size">
          <p><b>&lt;US$100,000</b><br/>In certain circumstances, Deviate Labs will provide services in exchange for equity.</p>
        </Card>
        <Card headline="Value-Add">
          <p>Deviate Ventures prides itself in its ability to provide marketing advisory services for all portfolio companies. Drawing upon the learnings derived from operating a world-class marketing consulting firm, we provide a go-to-market perspective honed on the frontlines and equipped with the latest frontier technology.</p>
        </Card>
      </div>
    </section>

    <StripedCtaSection
      headline="Contact the Deviate Ventures Team"
    />

    <section className={`section ${css.portfolio}`}>
      <div className="sectionInner">
        <h2 className="underlined">Portfolio</h2>

        <div className={css.cards}>
          {ventures.map((venture) => <Card key={venture.url} href={venture.url} target="_blank">
            <div className={css.ventureLogoWrapper}>
              {venture.image}
            </div>
          </Card>)}

        </div>
      </div>
    </section>


  </GenericLayout>;
}

